<template>
  <div class="page-bg">

    <!-- Header -->
    <Header headerTitle="充电信息"></Header>
    <!-- order Info -->
    <div>
      <section>
        <div class="cardAddress panel">
          <div class="title">终端信息</div>
          <div v-if="orderDetail.parkingSpace">
            <div class="equipment-desc">终端编号: {{ orderDetail.parkingSpace.equipmentCode }}</div>
            <div v-if="orderDetail.parkingSpace.describe1" class="equipment-desc">{{ orderDetail.parkingSpace.describe1 }}</div>
            <div v-if="orderDetail.parkingSpace.describe2" class="equipment-desc">{{ orderDetail.parkingSpace.describe2 }}</div>
            <div v-if="orderDetail.parkingSpace.describe3" class="equipment-desc">{{ orderDetail.parkingSpace.describe3 }}</div>
          </div>
        </div>
        <div class="cardAddress panel " style="margin-top:8px">
          <div class="title">充电信息</div>
          <div class="equipment-desc">充电订单编号: {{ result.chargeInfo.chargeSeq }}</div>
        </div>
        <div class="infoCard panel">
          <p class="borderba">启动</p>
          <div class="divider" style="padding-top:5px;padding-bottom: 19px;height:55px">
            <h6>{{ result.chargeInfo.chargeStartTime }}</h6>
          </div>
          <h6 class="dateAppche">{{ result.chargeInfo.chargeStatus === 4 ? '用户手动停止' : '异常停止' }}</h6>
          <p class="borderba">停止</p>
          <div style="border:0;padding-top:2px;">
            <h6>{{ result.chargeInfo.chargeEndTime }}</h6>
          </div>
        </div>
        <div class="cell-row" style="margin-top:8px">
          <van-cell title="充电时长" :value="result.chargeInfo.chargeDurationFormat" size="large" />
          <van-cell title="充电度数" :value="(result.chargeInfo.chargeDegree||0)+'度'" size="large" />
          <van-cell title="充电费用" :value="result.chargeInfo.chargeAmount+'元'" size="large" />
          <van-cell class="desc" title="" :value="`充电服务费${result.chargeInfo.chargeFee}/度`" />
        </div>
      </section>
      <!-- footer -->
      <div class="footer-bg">
        <van-row gutter="12" class="footer-row" >
          <van-col span="12">
            <b-btn
              v-b-modal.modal-center
              class="default-btn"
              @click="goParking()"
              >返回首页</b-btn>
          </van-col>
          <van-col span="12">
            <b-btn
              class="primary-btn"
              v-b-modal.modal-center
              @click="handleCharge()"
              >启动充电</b-btn>
          </van-col>
        </van-row>
        <div v-if="orderDetail.parkingSpace.selfService === 1" class="footer-tip" style="color: #575757">车辆离场后，请在订单信息完成支付</div>
      </div>
    </div>

    <b-modal ref="notice-start-charge" id="notice-start-charge" no-close-on-backdrop class="notice" static ok-title="启动充电"
             cancel-title="取消" @ok="startCharge(1)">
      <h5 style="margin-top: 12px"><b><strong>{{ noticeTitle }}</strong></b></h5>
      <p class="my-sm-6" style="margin-bottom:5px !important;padding:0 25px;font-size:14px;">
        {{ noticeInfo }}
      </p>
    </b-modal>

    <b-modal ref="notice-charge-tip" id="notice-charge-tip" no-close-on-backdrop class="notice" static hide-footer
             cancel-title="取消" @ok="startCharge(1)">
      <h5 style="margin-top: 12px"><b><strong>{{ noticeTitle }}</strong></b></h5>
      <p class="my-sm-6" style="margin-bottom:5px !important;padding:0 25px;font-size:16px;">
        安全充电启动中，请耐心等待，预计需要<span style="color: #0061B1"> {{ noticeInfo }} </span>启动成功。启动中，请勿拔枪启动过程中拔枪会造成充电异常，并可能发生安全风险
      </p>
    </b-modal>

    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>

  </div>
</template>
<script>
import {
  cancelOrder,
  orderListByDetails,
  cancelOrderConfirm,
  orderStatus,
  manualEnter, startCharge
} from "@/api/order.js";
import { dateAdd, formatDate, hourtoMinute }from "@/utils/DateFomatUtil";
import {parkingTime} from "@/api/time";
export default {
  name: "StaySubmitOrder",
  data() {
    return {
      orderId: "", //订单Id
      result: {}, //数据
      phone: "400-115-0606", //手机号
      confimList: "", //取消订单
      appointTime: "", //预约时长
      longitude: 0, //当前经度
      latitude: 0, //当前维度
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "", //提示类型
      hideButton: true,
      orderDetail: null,
      type: "0",
      noticeTitle: '',
      noticeInfo: '',
      chargingTime: 90,
      parkingTimeInterval: undefined,
      chargeInterval: undefined,
      chargeSeq: undefined
    };
  },
  created() {
    this.orderId = this.$route.params.orderId;
    this.chargeSeq = this.$route.params.chargeSeq;

    parkingTime({
      orderId: this.orderId,
      chargeSeq: this.chargeSeq
    }).then(response => {
      if (response.data.status == 200) {
        this.result = response.data.result;
      }
    });
    this.handleOrderDetail()
  },
  methods: {
    handleOrderDetail() {
      orderListByDetails({
        orderId: this.orderId
      }).then(res => {
        this.orderDetail = res.data.result;
      });
    },
    goParking() {
      this.$router.push("/");
    },
    noticeStartCharge() {
      this.noticeTitle = '确定启动充电？'
      this.noticeInfo = '充电前，请先熄火，电动汽车需要在熄火的状态下进行充电，建议同时关闭车内电源'
      this.$refs["notice-start-charge"].show();
    },
    handleCharge() {
      this.noticeStartCharge()
    },
    startCharge() {
      const self = this

      startCharge({
        orderId: this.orderId
      }).then(res => {
        if (res.status === 200 && res.data.status === 200 && res.data.result.chargeResponse.SuccStat === 0) {
          this.startChargeRes = res

          this.noticeTitle = '温馨提示'
          this.noticeInfo = this.chargingTime + 's'
          this.$refs["notice-charge-tip"].show();

          this.chargeInterval = setInterval(function () {
            if(self.chargingTime <= 0) {
              clearInterval(self.parkingTimeInterval)
              clearInterval(self.chargeInterval)
              self.$refs["notice-charge-tip"].hide()

              self.tipShow = "1" + Math.random() * 1000;
              self.message = '充电启动超时, 请重试';
              self.tipType = "warning";
            }

            self.chargingTime = self.chargingTime - 1
            self.noticeInfo = self.chargingTime + 's'
          }, 1000);

          this.parkingTimeInterval = setInterval(function () {
            self.handleParkingTime()
          }, 3000);
        } else {
          self.tipShow = "1" + Math.random() * 1000;
          self.message = '充电启动失败, 请重试';
          self.tipType = "warning";
        }
      })
    },
    handleParkingTime() {
      parkingTime({orderId: this.orderId}).then(res => {
        if (res.data.status == 200) {
          this.result = res.data.result;

          if(this.result.chargeInfo && this.result.chargeInfo.chargeStatus === 2){
            this.$refs["notice-charge-tip"].hide()
            this.$router.push("/chargeInfo/" + this.orderId);
          }
        }
      })
    },
    handleLockTip() {
      this.noticeTitle = '温馨提示'
      this.$refs["lock-tip"].show();
    },
    handleDownLock() {
      setTimeout(() => {
        this.message = '操作成功'
        this.tipType = "success";
        // this.tipShow = "1" + Math.random() * 1000;
      }, 1000)
    },
    handleCallLockService() {
      window.location.href = "tel://4001150606";
    },
    ruler: function() {
      this.$router.push("/ruler");
    },
    handleManualEnter(){
      manualEnter({id:this.orderId}).then(response => {
        if (response.data.status == 200) {
          this.$router.push("/Time/" + this.orderId);
        } else {
          this.tipShow = "1" + Math.random() * 1000;
          this.tipType = "warning";
          this.message = "入场失败";
        }
      })
    },
    call() {
      this.$refs.myModalRef.show();
    }
  },
  destroyed() {
    if (this.ostatus != null) {
      clearInterval(this.ostatus);
    }
  }
};
</script>
<style >
section {
  margin-bottom: 50px !important;
}
section .cardId {
  border-bottom: 2px solid #efefef;
  padding: 5px 0;
  text-align: left;
}
section .cardAddress {
  padding: 20px 0;
  text-align: left;
  border-bottom: 1px solid #EEEEEE;
}
section .terminal-info {
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  text-align: left;
  border-bottom: 2px solid #efefef;
}
.charge-price-info {
  display: flex;
  flex-direction: row;
}
.price-tip {

}
section .cardAddress h6 {
  margin: 0 auto;
  padding: 0px;
}
section .cardAddress p {
  font-size: 13px;
  width: 85%;

  display: inline-block;
  color: #666;
}
section .cardAddress .equipment-desc-container {
  display: flex !important;
  justify-content: left;
  align-items: center;
  flex-direction: column;
  margin: 8px 0 16px 0;
}
section .infoCard {
  text-align: left;
  padding: 20px 0;
  /* padding-bottom: 25px; */
  border-bottom: 2px solid #efefef;
}
section .infoCard .dateAppche {
  padding-top: 18px;
  color: #242c33;
  padding-left: 5px;
  font-size: 15px;
  padding-bottom: 10px;
}
section .infoCard .borderba {
  background-color: #0066B1;
  border-radius: 4px;
  display: inline-block;
  padding: 3px 13px;
  color: #fff;
  font-size: 14px;
  /* margin-top: 14px; */
  margin-top: 0px;
}
section .infoCard div {
  display: inline-block;
  text-align: right;
  float: right;
  /* width: 80%; */
   width: 73%;
  border-bottom: 2px solid #efefef;
}
section .infoCard div p {
  font-size: 13px;
  color: #666;
  padding-bottom: 12px;
}
section .money {
  /* text-align: left;
  padding: 10px 0; */
  border-bottom: none;
}
section .money2 {
  text-align: right;
  padding: 10px 0;
  font-size: 11px;
  color: #666;
}
section .money span {
  display: inline-block;
  text-align: right;
  float: right;
}
.cancelOrders .modal {
  top: auto !important;
  bottom: 40% !important;
  margin: 0 10%;
}
.cancelOrders .modal .modal-dialog .modal-body {
  margin: 0px;
  padding: 0px;
}
.cancelOrders .modal .modal-dialog .modal-body .my-4 {
  font-size: 20px;
  color: #666;
}
.cancelOrders header {
  padding: 0px;
}
.cancelOrders .modal-footer {
  margin-left: 0px;
}
.cancelOrders footer {
  text-align: center;
}

footer {
  bottom: 0px;
  padding: 0 5%;
}
.space-name {
  margin-top: 8px;
  font-size: 24px;
  font-weight: 500;
  color: #0061B1;
  line-height: 24px;
}
.footer-tip {
  margin-top: 8px;
  width: 100%;
  height: 14px;
  font-size: 14px;
  font-weight: 400;
  color: #575757;
  line-height: 14px;
  text-align: left;
}
.lock-down-tip {
  color: #0061B1;
}
.equipment-desc {
  width: 100%;
  text-align: left;
}
.equipment-desc-container {
  color: #575757;
}
</style>
<style>
  .page-bg{
    height: 100%;
    background: #F7F9FD;
  }
  .panel{
    background: white;
    padding: 12px !important;
  }
  .footer-bg{
    /* position: fixed; */
    width: 100%;
    bottom: 5%;
    padding: 0px 4%;
    margin-top: 3%;

  }
  .footer-bg .footer-row .primary-btn{
    background-color: #0061B1;
    color: #FFFFFF;
    width: 100%;
  }
  .footer-bg .footer-row .default-btn{
    background-color: white;
    color: #352f2f;
    width: 100%;
  }
  section .cardAddress .title {
    font-size: 17px;
    font-weight: bold;
    text-align: left;
  }
  section .cardAddress .equipment-desc {
    font-size: 14px;
  }
  .cell-row .van-cell .van-cell__title{
    flex: none;
  }
  .cell-row .van-cell .van-cell__value{
    font-weight: bold;
    color: #524e4e
  }
  .cell-row .desc .van-cell__value{
    color: #908a8a;
    font-size: 13px;
  }
  .divider{
    border-bottom: 1px solid #efefef !important;
  }

</style>



